import { format } from 'date-fns';
import { memo, useMemo } from 'react';
import { Draggable, DraggableProvided } from 'react-beautiful-dnd';

import { DataTableCell } from 'components/table/DataTableCell';
import { DataTableRow } from 'components/table/DataTableRow';
import { TableControls } from 'components/table/TableControls';
import { Typography } from 'components/Typography/Typography';
import { usePermissions } from 'hooks/usePermissions';
import { Story } from 'types/story';
import { fDateFromMoscow } from 'utils/formatTime';

import { PhotoPaths } from 'types/photo';
import { getImageUrl } from 'utils/getImageUrl';

import s from './StoryTableRow.module.scss';

interface StoryTableRowProps {
  row: Story;
  index: number;
  onEditRow: (id: number) => void;
  onDeleteRow: (id: number) => void;
}

export const StoryTableRow = memo(({ row, index, onEditRow, onDeleteRow }: StoryTableRowProps) => {
  const { title, created_at, id, active, images } = row;
  const { can } = usePermissions();

  const popoverButtons = useMemo(
    () => [
      {
        text: 'Редактировать',
        callback: () => onEditRow(id),
      },
      {
        text: 'Удалить',
        access: can('create', 'admin') || can('create', 'moderator'),
        color: '#D32F2F',
        callback: () => onDeleteRow(id),
      },
    ],
    [can, id, onDeleteRow, onEditRow]
  );

  const color = active ? undefined : '#00000061 !important';

  return (
    <Draggable key={`${index}`} draggableId={`dnd-${index}`} index={index}>
      {(draggableProvided: DraggableProvided) => (
        <DataTableRow
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
          droppableRef={draggableProvided.innerRef}
          sx={{ maxHeight: '151px', height: '151px' }}
          hover
        >
          <DataTableCell>
            <img
              className={s.img}
              src={getImageUrl(images.mobile, PhotoPaths.IMAGE)}
              alt={`img-${index}`}
              loading="lazy"
            />
          </DataTableCell>

          <DataTableCell>
            <Typography sx={{ color }}>{title}</Typography>
          </DataTableCell>

          <DataTableCell>
            <Typography sx={{ color }}>
              {created_at ? format(fDateFromMoscow(created_at), 'dd.MM.yyyy') : ''}
              <br />
              {created_at ? format(fDateFromMoscow(created_at), 'HH:mm:ss') : ''}
            </Typography>
          </DataTableCell>

          <DataTableCell sx={{ width: '56px', paddingLeft: '16px' }}>
            <TableControls id={id} buttons={popoverButtons} />
          </DataTableCell>
        </DataTableRow>
      )}
    </Draggable>
  );
});
